class Sliderv2 extends HTMLElement {
    constructor() {
        super();

        this.swiperInit();

    }

    swiperInit() {
        this.swiper = new Swiper(".product-medias__thumbnail--main", {
            slidesPerView: 5,
            spaceBetween: 8,
            direction: "horizontal",
            allowTouchMove: true,
            loopPreventsSlide: false,
            edgeSwipeDetection: "prevent",
            preventClicks: true,
            preventClicksPropagation: true,
            touchMoveStopPropagation: false,
            a11y: false,
            speed: 400,
            threshold: 15,
            touchStartForcePreventDefault: false,

            breakpoints: {
                360: {
                    spaceBetween: 15,
                },
            },
        });

        this.swiper2 = new Swiper(".product-medias__main--main", {
            allowTouchMove: true,
            threshold: 10,
            thumbs: {
                swiper: this.swiper,
                autoScrollOffset: 0,
                thumbsContainerClass: "thumbs-container",
            },
            noSwipingClass: "swiper-no-swiping",
            breakpoints: {
                1140: {
                    allowTouchMove: false,
                },
            },
            navigation: {
                nextEl: ".products-thumb-v2__next ",
                prevEl: ".products-thumb-v2__prev ",
            },
        });

        this.swiper2.on("slideChange", this.updateSlide.bind(this));
    }
}

customElements.define('product-medias', Sliderv2);